<template>
  <div class="container-fluid vh-90 d-flex align-items-center">
    <article class="m-auto">
      <section class="row">
          <div class="mt-3 text-center">
            <img src="../../assets/join_car.png" class="w-50"/>
          </div>
          <p class="text-center fs-title fw-bold">가입 신청이 완료 되었습니다.</p>
          <p class="text-center fs-5">
            화물맨 차주 어플을 통해<br/>
            운송료 예치금 출금이 가능합니다.
          </p>
          <div class="mb-4">
            <div class="text-center fs-5 fw-bolder">
              아이디: {{ loginInfo.id }}
            </div>
            <div class="text-center fs-5 fw-bolder">
              비밀번호: {{ loginInfo.pass }}
            </div>
          </div>
          <p class="text-center fs-5">
            아래의 화물맨 어플 설치(실행)<br/>
            버튼을 클릭해주세요.
          </p>
      </section>
      <footer class="footer d-flex flex-column mt-3 d-flex gap-2">
        <button class="btn btn-primary col-12 rounded-pill" @click="moveHmm">화물맨 어플 설치(실행)하기</button>
        <button class="btn btn-light bg-dark-subtle col-12 rounded-pill" @click="moveHomepage">닫기</button>
      </footer>
    </article>
  </div>
</template>

<script>

/**
 * 간편회원가입 - 가입 완료페이지
 */
export default {
  name: "CompletionScreenPoint",
  data(){
    return {
      iv: this.$CryptoJS.enc.Hex.parse('0000000000000000'),
      key: this.$CryptoJS.enc.Utf8.parse('alkdjalsdjivlake'),
      loginInfo:{
        id:'',
        pass:''
      }
    }
  },
  mounted() {
    this.initLoginInfoBy(this.$store.getters.getLoginInfo);
  },
  methods:{
    moveHomepage(){
      window.location.href = "https://www.2424-2424.com";
    },
    moveHmm(){
      window.location.href = "https://play.google.com/store/apps/details?id=ktc.cargo.driver";
    },
    isEmpty(value) {
      return value === undefined || value === null || String(value).trim() === '';
    },
    initLoginInfoBy(loginInfo1 = this.$store.getters.getLoginInfo) {
      const loginInfo = loginInfo1;
      this.loginInfo.id = loginInfo.id;
      this.loginInfo.pass = loginInfo.pass;
    }
  },
}
</script>

<style scoped>
button {
  height: 50vw; /* 높이를 화면 너비의 5%로 설정 (조절 가능) */
  max-height: 50px;
  min-height: 20px;
}
.vh-90 {
  height: 90vh;
}
</style>